import { render, staticRenderFns } from "./PatientImagesModal__Style#Drawer.vue?vue&type=template&id=0b28c293&scoped=true&"
import script from "./PatientImagesModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./PatientImagesModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./PatientImagesModal__Style#Drawer.vue?vue&type=style&index=0&id=0b28c293&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b28c293",
  null
  
)

export default component.exports